import { ServiceBase, Result } from "./ServiceBase";
import { Division } from '../models/Division';

export default class DivisionService extends ServiceBase {

    public static async list(): Promise<Result<Division[]>> {

        var result = await this.requestJson<Division[]>({
            url: `/api/Division/list/`,
            method: "GET"            
        });

        return result;
    }
}
